import { EventEmitter as Emitter } from "events";

const EventEmitter = new Emitter();

export default EventEmitter;
